import {Component} from "../../../gvf/js/component";
import {GvfUiService} from "../../../gvf/js/gvf-ui-service";
import {GvfService} from "../../../gvf/js/gvf-service";
import {FormField} from "../form-field/form-field";
import {UtilsService} from "../../../cp/js/utils-service";

export class FormFieldCutOnPlan extends FormField{
    constructor(scope,$root){
        super(scope,$root);
        this.filteredIndexes = null;
    }

    isFilteredIndex(dashboardIndex){
        if(this.filteredIndexes===null){
            const filters = this.$root.closest("form").getValues();
            this.filteredIndexes = {};
            for(let f in filters){
                if(f.indexOf("vi_filter")===0){
                    for(let target in filters[f]){
                        const parts = filters[f][target].split(".");
                        this.filteredIndexes[parts[0]] = true;
                    }
                }
            }
        }
        return !!this.filteredIndexes["["+dashboardIndex+"]"];
    }

    updateArea($item){
        const $itemContent = $item.find(".grid-stack-item-content");
        $itemContent.html("<div class='grid-stack-item-label'>Cargando...</div>");
        const data = $item.data("dashboard");
        let filters = {};
        if(this.$form.length>0){
            filters = this.$form.getValues();
            delete filters.content;
            delete filters.id;
        }
    }

    updateDashboardValue(){
        const items = [];
        this.$root.find(".grid-stack-item").each(
            (index,item) => {
                let data = $(item).data("dashboard");
                let obj = this.dataItems.filter((i) => {
                    return i.id==data.id;
                });
                if(obj[0]){
                    data = obj[0];
                }
                //update current dimensions/positions
                data.x = Math.round($(item).attr("gs-x"));
                data.y = Math.round($(item).attr("gs-y"));
                if(data["changed"]){ //&& $itemWidget && parseInt($(item).attr("data-gs-width"))==$itemWidget["width"] && parseInt($(item).attr("data-gs-height"))==$itemWidget["height"]
                    data.w = this.changeLengthToPercentage(data["lengthHeight"],true);// $(item).attr("data-gs-width");
                    data.h = this.changeLengthToPercentage(data["lengthWidth"],false);// $(item).attr("data-gs-height");
                }else{
                    data.w = $(item).attr("gs-w");
                    data.h = $(item).attr("gs-h");

                    data["lengthHeight"] = data.lengthHeight ?? this.changePercentageToLength(data.h,false);
                    data["lengthWidth"] = data.lengthWidth ?? this.changePercentageToLength(data.w,true);
                }
                data["changed"] = false;
                $(item).data("dashboard",data);
                items.push(data);
                this.dataItems = items;
                var $itemContent = $(item).find(".grid-stack-item-content");
                this.viewParamsItem($(item),$itemContent,true);
            }
        );
        this.$root.find(this.scope+"__data").val(JSON.stringify(items));
        this.checkAreaSelected();
        this.setVal(this.dataItems);
    }

    checkAreaSelected(){
        let errors = [];
        //var items = JSON.parse(this.$root.find(this.scope+"__data").val());
        var items = this.dataItems;//JSON.parse(this.$root.find(this.scope+"__data").val());
        if(items){
            var resp = items.filter((item) => {
                return item.x==0;
            });

            for(let x = 0; x<100; x++){
                var heightMeasurament = 0;
                var itemsHeight = items.filter((item) => {
                    return x>=parseInt(item.x) && x<(parseInt(item.x)+parseInt(item.width));
                });
                for(let i = 0; i<itemsHeight.length; i++){
                    heightMeasurament += this.calculateHeight(itemsHeight[i]); //parseInt(itemsHeight[i].height);
                }
                if(itemsHeight.length>1){
                    heightMeasurament += (itemsHeight.length-1)*this.findMember("container").data("loss-of-cut");
                }
                if(this.findMember("container").data("flat-height")<Math.ceil(heightMeasurament) && itemsHeight.length>=1){
                    errors.push({column: x,messurament: heightMeasurament});
                }
            }
            for(let y = 0; y<100; y++){
                var widthMeasurament = 0;
                var itemsWidth = items.filter((item) => {
                    return y>=parseInt(item.y) && y<(parseInt(item.y)+parseInt(item.height));
                });
                for(let j = 0; j<itemsWidth.length; j++){
                    widthMeasurament += this.calculateWidth(itemsWidth[j]);// parseInt(itemsWidth[i].width);
                }
                if(itemsWidth.length>1){
                    widthMeasurament += (itemsWidth.length-1)*this.findMember("container").data("loss-of-cut");
                }
                if(this.findMember("container").data("flat-width")<Math.ceil(widthMeasurament) && itemsWidth.length>=1){
                    errors.push({row: y,messurament: widthMeasurament});
                }
            }
        }
        return errors;

    }

    calculateWidth(item){
        return Math.ceil(parseInt(item["lengthWidth"]));
    }

    calculateHeight(item){
        return Math.ceil(parseInt(item["lengthHeight"]));
    }

    calculateRatioAppearance(){
        let w = this.findMember("container").data("flat-width");
        let h = this.findMember("container").data("flat-height");
        return Math.round(parseInt(h)/parseInt(w)*100);
    }

    changePercentageToLength(percentageInt,width = true){
        if(width){
            return Math.round((this.findMember("container").data("flat-width")/100)*percentageInt);
        }else{
            return Math.round((this.findMember("container").data("flat-height")/this.calculateRatioAppearance())*(percentageInt));
        }
    }

    changeLengthToPercentage(length,width = true){
        if(width){
            return (length*100)/this.findMember("container").data("flat-width");
        }else{
            return (length*this.calculateRatioAppearance())/this.findMember("container").data("flat-height");
        }
    }

    fitItems($container,delayed){
        setTimeout(
            () => {
                $container.find(".grid-stack-item-value").each(
                    (index,item) => {
                        textFit(item,{alignVert: true,alignHoriz: true});
                    }
                );
                $container.find(".grid-stack-item-value-comp").each(
                    (index,item) => {
                        textFit(item,{alignHoriz: true,multiLine: false,maxFontSize: 14});
                    }
                );
                $container.find(".js-form-field-cut-on-plan__ht-container").each(
                    (index,item) => {
                        if($(item).data("htinstance")){
                            const height = $(item).closest(".grid-stack-item").height()-parseInt($(item).closest(".grid-stack-item-body").css("padding-top"));
                            $(item).data("htinstance").updateSettings({"height": height});
                            $(item).data("htinstance").render();
                        }
                    }
                );
                $container.find(".js-form-field-cut-on-plan__chart-container").each(
                    (index,item) => {
                        if($(item).data("chartinstance")){
                            let height = $(item).closest(".grid-stack-item").height()-parseInt($(item).closest(".grid-stack-item-body").css("padding-top"));
                            const $legend = $(item).find(".ct-legend");
                            if($legend.length>0){
                                height -= $legend.height();
                            }
                            $(item).css("height",height);
                            $(item).data("chartinstance").update();
                        }
                    }
                );
            },
            delayed?300:10
        );
    }

    initDashboard($initial = false){
        let $w = this.findMember("container").data("flat-width");
        let $h = this.findMember("container").data("flat-height");
        let padding = Math.round($h/$w*100);
        if($h!=1000 || $w!=1000){
            padding = padding?padding:200;
        }else{
            padding = 200;
        }
        this.gridstack = GridStack.init(
            {
                alwaysShowResizeHandle: /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent),
                resizable: {
                    handles: "e, se, s, sw, w, ne, n, nw"
                },
                removable: true,
                disableResize: false,
                disableDrag: false,
                column: 100,
                minRow: padding,
                maxRow: padding,
                margin: 4,
                float: true,
                disableOneColumnMode: true
                /*
                cellHeight: 10,
                acceptWidgets: false,
                alwaysShowResizeHandle: true,
                animate: false,
                auto: true,
                column: 12,
                disableDrag: false,
                disableOneColumnMode: true,
                disableResize: false,
                draggable: true,
                dragOut: true,
                float: true,
                disableOneColumnMode: true,
                itemClass: 'grid-stack-item',
                maxRow: 10,
                minRow: 10,
                oneColumnDomSort: false,
                placeholderClass: 'grid-stack-placeholder',
                placeholderText: '',
                resizable: {
                    autoHide: false,
                    handles: 'n, nw, w, sw, s, se, e, ne'
                },
                removeable: false,
                removeTimeout: 2000,
                rtl: false,
                staticGrid: true,*/
            }
        );

        this.$dashboardContainer.data("gridstack");

        this.changeInformationValues($initial);
    }

    viewParamsItem($itemGridStackItem,$itemContent,enable){
        $(".grid-stack-item-content").removeClass("is-selected");
        var componentMeasuresItemthis = this.findMember("component-measures-item");
        componentMeasuresItemthis.attr("data-cutout-id","");
        this.findMember("component-measures-item").hide();
        if($itemContent){
            var $itemData = this.getWidget($itemContent.attr("data-cutout-id"));
            if(enable && $itemData){
                $itemContent.addClass("is-selected");
                componentMeasuresItemthis.attr("data-cutout-id",$itemContent.data("cutout-id"));
                this.findMember("component-measures-item-height").val($itemData["lengthHeight"]);
                this.findMember("component-measures-item-width").val($itemData["lengthWidth"]);
                componentMeasuresItemthis.show();
            }
        }
    }

    getWidget(widgetId){
        if(this.dataItems){
            let $dataItem = this.dataItems.filter((item) => {
                return widgetId==parseInt(item.id);
            });
            if($dataItem[0]){
                $dataItem = $dataItem[0];
                $dataItem["height"] = this.changeLengthToPercentage($dataItem["lengthHeight"],false);
                $dataItem["width"] = this.changeLengthToPercentage($dataItem["lengthWidth"],true);
                return $dataItem;
            }
        }
        return null;

    }

    getItemToChange(widgetId){
        let widgets = this.gridstack.engine.nodes;
        let resp = widgets.filter((item) => {
            return parseInt(widgetId)==parseInt(item.id);
        });
        return resp[0].el;
    }

    removeWidget(widgetId){
        this.gridstack.removeWidget(this.getItemToChange(widgetId));
        this.viewParamsItem();
        this.isPosibleAddWidget();
    }

    addWidgets(widgets){
        for(let y = 0; y<widgets.length; y++){
            this.addWidget(widgets[y]);
            //this.addWidget();
        }
    }

    updateGridData(widgetId,dataItems){
        var $dataItem = this.getWidget(widgetId);
        $dataItem["changed"] = true;
        this.gridstack.update($("#"+widgetId),{w: $dataItem["w"],h: $dataItem["h"]});
    }

    updateMeasuramentsWidget(widgetId,width,height){
        var $items = [];
        if(widgetId){
            let $dataItem = this.getWidget(widgetId);
            if(width){
                $dataItem["lengthWidth"] = width;
                $dataItem["w"] = Math.round(this.changeLengthToPercentage(width,true));
                $dataItem["changed"] = true;
            }
            if(height){
                $dataItem["lengthHeight"] = height;
                $dataItem["h"] = Math.round(this.changeLengthToPercentage(height,false));
                $dataItem["changed"] = true;
            }
            if($dataItem){
                for(let i = 0; i<this.dataItems.length; i++){
                    if(this.dataItems[i]["id"]==widgetId){
                        this.gridstack.update(this.getItemToChange(widgetId),$dataItem);
                        $items.push($dataItem);
                    }else{
                        $items.push(this.dataItems[i]);
                    }
                }
                this.dataItems = $items;
            }
            this.setVal(this.dataItems);
        }
        this.changeWidgetMeasurament(widgetId);
    }

    changeWidgetMeasurament(widgetId){
        let $widget = document.getElementById("measurament-"+widgetId);
        let $itemData = this.dataItems.filter((item) => {
            return widgetId==parseInt(item.id);
        });
        if($itemData[0]){
            $itemData = $itemData[0];
            $widget.innerHTML = "Ancho: "+$itemData["lengthWidth"]+this.findMember("container").data("meassuraments-unit")+" x "+"Alto: "+$itemData["lengthHeight"]+this.findMember("container").data("meassuraments-unit");
        }
        if(this.changeLengthToPercentage($itemData["lengthWidth"])>10){
            $("#measurament-"+widgetId).show();
        }else{
            $("#measurament-"+widgetId).hide();
        }
    }

    addWidget(data = null){
        if(!data){
            data = {
                w: Math.round(this.changeLengthToPercentage(this.findMember("container").data("cut-min-width"),true)),
                h: Math.round(this.changeLengthToPercentage(this.findMember("container").data("cut-min-height"),false)),
                id: Math.floor((Math.random()*(99999-10000+1))+10000),
                lengthWidth: this.findMember("container").data("cut-min-width"),
                lengthHeight: this.findMember("container").data("cut-min-height"),
                changed: false
            };
        }
        if(this.gridstack.willItFit(data)){
            this.findMember("add-new-cut").removeClass("has-error");
            this.gridstack.addWidget("<div class='grid-stack-item' gs-min-w='"+Math.round(this.changeLengthToPercentage(this.findMember("container").data("cut-min-width"),true))+"' gs-min-h='"+Math.round(this.changeLengthToPercentage(this.findMember("container").data("cut-min-height"),false))+"' data-lengthWidth='"+data["lengthWidth"]+"' data-lengthHeight='"+data.lengthHeight+"' id='"+data.id+"'><div class='grid-stack-item-content' data-id='"+data.id+"' data-cutout-id='"+data.id+"'><div class='u-row web-form-field-cut-on-plan__component-measures-parentable-item' >\n"+
                "    <div class='web-form-field-cut-on-plan__component-measures-table-item'>\n"+
                "        <div class='web-form-field-cut-on-plan__component-measures-table-inner-item js-form-field-cut-on-plan__item-display-data' id='measurament-"+data.id+"'>Ancho: "+data.lengthWidth+this.findMember("container").data("meassuraments-unit")+" x Alto: "+data.lengthHeight+this.findMember("container").data("meassuraments-unit")+"</div>\n"+
                "    </div>\n"+
                "</div></div></div>",data);
            $(".grid-stack-item").last().data("dashboard",data);
            this.updateDashboardValue();
        }else{
            this.findMember("add-new-cut").addClass("has-error");
        }
    }

    getVal(){
        //return this.dataItems;
        /*if(this.isHidden){
            return this.$root.val();
        }else if(this.isCheck){
            return this.$check.get(0).checked;
        }else{
            return this.$root.find(":input").val();
        }*/
    }

    setVal(value,noEvent){
        let values = {};
        values.value = value;
        values.errors = this.checkAreaSelected();
        values.dimensions = {
            "flat-width": this.findMember("container").data("flat-width"),
            "flat-height": this.findMember("container").data("flat-height"),
            "meassuramentsUnit": this.findMember("container").data("meassuraments-unit"),
            "cutMinWidth": this.findMember("container").data("cut-min-width"),
            "cutMinHeight": this.findMember("container").data("cut-min-height"),
            "lossOfCut": this.findMember("container").data("loss-of-cut"),
            "textRequireCuts": this.findMember("container").data("text-require-cuts"),
            "imageAssing": this.findMember("container").data("image-assign"),
        };
        // if(values){
        //     this.$value.val(values?JSON.stringify(values):"");
        //     this.$root.toggleClass("has-value",!!this.$value.val());
        // }else{
        //this.$value.val(values?JSON.stringify(values):"");
        this.$value.val(JSON.stringify(values));
        // }
        if(value){
            this.$input.val(values?JSON.stringify(values):"");
        }else{
            this.$input.val("");
        }
        if(!noEvent){
            this.$root.trigger("formField:changeVal");
        }
    }

    changeDisplayBoard($w,$h,$initial = false){
        if($w && $h){
            if($w!=this.findMember("container").data("flat-width") || $h!=this.findMember("container").data("flat-height")){
                document.getElementById("js-form-field-cut-on-plan__component-measures-item-width").innerHTML = "Ancho "+$w+this.findMember("container").data("meassuraments-unit");
                document.getElementById("js-form-field-cut-on-plan__component-measures-item-height").innerHTML = "Alto "+$h+this.findMember("container").data("meassuraments-unit");
                this.findMember("container").data("flat-width",$w);
                this.findMember("container").data("flat-height",$h);
                let padding = Math.round($h/$w*100);
                this.findMember("canvas").css("padding-bottom",(padding+1)+"%");
                if(this.gridstack){
                    this.dataItems = [];
                    this.gridstack.removeAll();
                    this.dataItems = [];
                    this.viewParamsItem();
                    this.isPosibleAddWidget();
                    if(!$initial){
                        this.setVal(this.dataItems);
                    }
                    this.initDashboard();
                    this.gridstack.engine.maxRow = padding;
                    this.gridstack.engine.minRow = padding;
                }
            }
        }
    }

    changeInformationValues($initial = false){
        GvfService.endpoint(
            "/web/product-config/get-board-information-values",
            {
                gid: this.findMember("value").attr("name"),
                productConfigId: this.productConfigId,
                formData: this.$form.getValues()
            }
        ).then(
            (resp) => {
                if(resp.widthBoard && resp.heightBoard){
                    this.changeDisplayBoard(resp.widthBoard,resp.heightBoard,$initial);
                    let minWidth = this.findMember("container").data("cut-min-width");
                    if(resp.widthBoard<=this.minWidth){
                        minWidth = resp.widthBoard;
                    }else{
                        minWidth = this.minWidth;
                    }
                    this.findMember("component-measures-item-width").attr("min",minWidth);
                    this.findMember("container").data("cut-min-width",minWidth);
                    this.findMember("component-measures-item-height").attr("min",this.findMember("container").data("cut-min-height"));
                }
                if(resp.imageAssign){
                    if(this.findMember("container").data("image-assign")!=resp.imageAssign){
                        this.findMember("container").data("image-assign",resp.imageAssign);
                        this.findMember("container").css("background-image","url("+resp.imageAssign+")");
                    }
                }
                if($initial){
                    setTimeout(() => {
                        this.gridstack.removeAll();
                        this.dataItems = []; //this.initialValue;
                        for(let i = 0; i<this.initialValue.value.length; i++){
                            let data = {
                                w: Math.round(this.changeLengthToPercentage(this.initialValue.value[i].lengthWidth)),
                                h: Math.round(this.changeLengthToPercentage(this.initialValue.value[i].lengthHeight)),
                                id: this.initialValue.value[i].id,
                                lengthWidth: this.initialValue.value[i].lengthWidth,
                                lengthHeight: this.initialValue.value[i].lengthHeight,
                                changed: false
                            };
                            this.addWidget(data);
                        }
                        this.dataItems = this.initialValue.value;
                        this.setVal(this.initialValue.value);

                    },100);
                }
            }
        );
    }

    resizeMouseWidget(data){
        data["lengthWidth"] = this.changePercentageToLength(data.w);
        data["lengthHeight"] = this.changePercentageToLength(data.h,false);
        //this.gridstack.update(data.id,data);
        let widgets = this.dataItems;
        let newWidgets = [];
        for(let i = 0; i<widgets.length; i++){
            if(data.id==widgets[i].id){
                newWidgets.push({
                    changed: false,
                    h: data.h,
                    w: data.w,
                    id: data.id,
                    lengthWidth: data.lengthWidth,
                    lengthHeight: data.lengthHeight,
                    x: data.x,
                    y: data.y
                }); //data
            }else{
                newWidgets.push(widgets[i]);
            }
        }
        this.dataItems = newWidgets;
        this.viewParamsItem(null,$("#"+data.id).find(".grid-stack-item-content"),true);
        this.setVal(newWidgets);
        this.changeWidgetMeasurament(data.id);
    }

    moveMouseWidget(data){
        let widgets = this.dataItems;
        let newWidgets = [];
        for(let i = 0; i<widgets.length; i++){
            if(data.id==widgets[i].id){
                newWidgets.push({
                    changed: false,
                    id: data.id,
                    lengthWidth: data.lengthWidth,
                    lengthHeight: data.lengthHeight,
                    x: data.x,
                    y: data.y
                }); //data
            }else{
                newWidgets.push(widgets[i]);
            }
        }
        this.dataItems = newWidgets;
        this.viewParamsItem(null,$("#"+data.id).find(".grid-stack-item-content"),true);
        this.setVal(newWidgets);
    }

    isPosibleAddWidget(){
        if(this.gridstack.willItFit({
            w: 45,
            h: 10,
            id: Math.floor((Math.random()*(99999-10000+1))+10000),
            lengthWidth: this.changePercentageToLength(45,true),
            lengthHeight: this.changePercentageToLength(10,false),
            changed: false
        })){
            this.findMember("add-new-cut").removeClass("has-error");
        }
    }

    getMaxWidth(widgetId){
        let $dataItem = this.dataItems.filter((item) => {
            return widgetId==parseInt(item.id);
        });
        if($dataItem[0]){
            $dataItem = $dataItem[0];
        }
        let x = $dataItem["x"];
        let xWidth = 100-x;
        return this.changePercentageToLength(xWidth);
    }

    getMaxHeight(widgetId){
        let $dataItem = this.dataItems.filter((item) => {
            return widgetId==parseInt(item.id);
        });
        if($dataItem[0]){
            $dataItem = $dataItem[0];
        }
        let y = $dataItem["y"];

        let heightDimensions = Math.round(this.calculateRatioAppearance());
        let yHeight = heightDimensions-y;
        return this.changePercentageToLength(yHeight);
    }

    ready(){
        this.$dashboardContainer = this.findMember("container");
        this.$form = this.$root.closest(".js-form");
        this.$itemWorkerField = this.$root.findFormFieldByName("item_worker");
        this.gridstack = null;
        this.el = null;
        this.$value = this.findMember("value");
        this.$filterModal = this.$root.find(this.scope+"__filter-modal");
        var dataItems = {};
        this.$input = this.findMember("input");
        this.initialValue = this.$value.val()?JSON.parse(this.$value.val()):null;
        this.productConfigId = this.$form.closest(".js-mod-product-config").data("id");
        this.minWidth = this.findMember("container").data("cut-min-width");

        this.findMember("add").click(
            (ev) => {
                ev.preventDefault();
                this.addWidget();
            }
        );

        this.$dashboardContainer.on("resizestop",(event,el) => {
            let data = el.element[0].gridstackNode;
            this.resizeMouseWidget(data);
            this.isPosibleAddWidget();
        });

        this.$dashboardContainer.on("dragstop",(event,el) => {
            let data = event.target.gridstackNode;
            this.moveMouseWidget(data);
            this.isPosibleAddWidget();
        });

        this.$dashboardContainer.click(
            (ev) => {
                const $item = $(ev.target).closest(".grid-stack-item");
                const $content = $item.find(".grid-stack-item-content");
                this.viewParamsItem($item,$content,true);
            }
        );

        this.findMember("component-measures-item-height").change(
            (ev) => {

                ev.preventDefault();
                var $componentMeasuresItem = $(ev.currentTarget).closest(this.scope+"__component-measures-item").attr("data-cutout-id");
                this.updateMeasuramentsWidget($componentMeasuresItem,false,parseInt((ev.currentTarget).value));
            }
        );

        this.findMember("component-measures-item-width").change(
            (ev) => {

                ev.preventDefault();
                var $componentMeasuresItem = $(ev.currentTarget).closest(this.scope+"__component-measures-item").attr("data-cutout-id");
                this.updateMeasuramentsWidget($componentMeasuresItem,parseInt((ev.currentTarget).value)<=this.getMaxWidth($componentMeasuresItem)?parseInt((ev.currentTarget).value):this.getMaxWidth($componentMeasuresItem),false);
                if(parseInt((ev.currentTarget).value)>this.getMaxWidth($componentMeasuresItem)){
                    $(ev.currentTarget).val(this.getMaxWidth($componentMeasuresItem));
                }
            }
        );

        this.findMember("component-measures-item-height").focusout(
            (ev) => {
                ev.preventDefault();
                GvfService.delay(100,"focusout").then(()=>{
                    var $componentMeasuresItem = $(ev.currentTarget).closest(this.scope+"__component-measures-item").attr("data-cutout-id");
                    this.updateMeasuramentsWidget($componentMeasuresItem,false,parseInt((ev.currentTarget).value));
                });
            }
        );
        this.findMember("component-measures-item-width").focusout(
            (ev) => {
                ev.preventDefault();
                GvfService.delay(100,"focusout").then(()=>{
                    var $componentMeasuresItem = $(ev.currentTarget).closest(this.scope+"__component-measures-item").attr("data-cutout-id");
                    this.updateMeasuramentsWidget($componentMeasuresItem,parseInt((ev.currentTarget).value)<=this.getMaxWidth($componentMeasuresItem)?parseInt((ev.currentTarget).value):this.getMaxWidth($componentMeasuresItem),false);
                    if(parseInt((ev.currentTarget).value)>this.getMaxWidth($componentMeasuresItem)){
                        $(ev.currentTarget).val(this.getMaxWidth($componentMeasuresItem));
                    }
                });

            }
        );

        this.findMember("remove-widget-id").click(
            (ev) => {
                ev.preventDefault();
                var $componentMeasuresItem = $(ev.currentTarget).closest(this.scope+"__component-measures-item").attr("data-cutout-id");
                this.removeWidget($componentMeasuresItem);
                if(this.gridstack.engine.nodes.length==0){
                    this.dataItems = [];
                }
                this.updateDashboardValue();
                this.setVal(this.dataItems);
            });

        this.$form.find(this.scope+"__filter-submit").click(
            (ev) => {
                ev.preventDefault();
                $(".grid-stack-item").each(
                    (index,item) => {
                        if(this.isFilteredIndex($(item).data("dashboardIndex"))){ //only update if needed
                            this.updateArea($(item));
                        }
                    }
                );
            }
        );

        this.$form.on("formField:changeVal",
            (ev) => {
                this.changeInformationValues(false);

            });

        this.findMember("filter-toggle").click(
            function(ev){
                ev.preventDefault();
                this.$filterModal.modal("show");
            }
        );
        this.findMember("filter-submit").click(
            (ev) => {
                ev.preventDefault();
                this.$filterModal.modal("hide");
                $(".grid-stack-item").each(
                    (index,item) => {
                        if(this.isFilteredIndex($(item).data("dashboardIndex"))){ //only update if needed
                            this.updateArea($(item));
                        }
                    }
                );
            }
        );
        if(this.initialValue){
            this.initDashboard(true);
        }else{
            this.initDashboard();
        }
        /*setTimeout(() => {
            this.initDashboard();
        },100)*/
    }
}
